import React from 'react';
import { PageHeader } from 'antd';

import TableComponent from './components/Table';

const CoreMetrics: React.FC = () => (
  <>
    <PageHeader title="Countries" />
    <TableComponent />
  </>
);

export default CoreMetrics;
